export default __webpack_public_path__ + "static/char-s-33-ko-74a226d9a2c32f29ff14c3573f58b1f4.png";